<form [formGroup]="form" (ngSubmit)="onSave()" (keydown.enter)="$event.preventDefault()">
	@if (httpError == '400') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.terminaltemplate.shared.errors.bad-request' | translate }}
		</mat-error>
	}
	@if (httpError == '404') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.terminaltemplate.shared.errors.not-found' | translate }}
		</mat-error>
	}
	@if (httpError == '500') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.terminaltemplate.shared.errors.internal-server-error' | translate }}
		</mat-error>
	}

	<h1 mat-dialog-title class="notification-title no-select">
		{{ 'mes.administration.terminaltemplate.edit.window-header' | translate }}
	</h1>

	<mat-dialog-content style="padding-top: 20px">
		<div class="optional-form-fields">
			@if (httpError == '409') {
				<mat-error>
					{{ 'mes.administration.terminaltemplate.shared.errors.duplicate' | translate }}
				</mat-error>
			}
			@if (controls['alias'].invalid) {
				<mat-error>
					{{ 'mes.administration.terminaltemplate.dialog.alias.error.' + getFirstValidationErrorName('alias') | translate }}
				</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.terminaltemplate.shared.alias' | translate }}
				</mat-label>
				<input maxlength="255" matInput formControlName="alias" />
			</mat-form-field>

			@if (controls['name'].invalid) {
				<mat-error>
					{{ 'mes.administration.terminaltemplate.dialog.name.error.' + getFirstValidationErrorName('name') | translate }}
				</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.terminaltemplate.shared.name' | translate }}
				</mat-label>
				<input maxlength="255" matInput formControlName="name" />
			</mat-form-field>

			<mat-label class="mat-body-1">
				{{ 'mes.administration.terminaltemplate.shared.group-list.label' | translate }}
			</mat-label>

			<div cdkDropList [cdkDropListOrientation]="'vertical'" (cdkDropListDropped)="onDropGroup($event)">
				@for (group of groupList.controls; track group; let i = $index) {
					<div class="drag-row" [formGroup]="group" cdkDrag cdkDragLockAxis="y">
						<mat-form-field appearance="fill" class="flex-fill">
							<mat-icon matPrefix cdkDragHandle class="drag-icon">reorder</mat-icon>
							<input maxlength="255" matInput formControlName="title" placeholder="{{ 'mes.administration.terminaltemplate.shared.title' | translate }}" />
						</mat-form-field>
						<mat-form-field appearance="fill" class="flex-fill">
							<input maxlength="255" matInput formControlName="source" placeholder="{{ 'mes.administration.terminaltemplate.shared.source' | translate }}" />
						</mat-form-field>
						<mat-form-field appearance="fill">
							<mat-select formControlName="datatype">
								@for (type of dataTypes; track type) {
									<mat-option [value]="type">
										{{ 'mes.administration.terminaltemplate.shared.types.' + type.toLowerCase() | translate }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
						<mat-form-field appearance="fill">
							<button mat-icon-button matSuffix class="delete-button" (click)="deleteGroupListItem(i)" type="button">
								<mat-icon svgIcon="acies_delete"></mat-icon>
							</button>
							<input maxlength="255" matInput formControlName="format" placeholder="{{ 'mes.administration.terminaltemplate.shared.format' | translate }}" />
						</mat-form-field>
					</div>
				}
			</div>

			<button mat-icon-button class="add-button" (click)="addGroupListItem()">
				<mat-icon svgIcon="acies_add_alt"></mat-icon>
			</button>

			<mat-label class="mat-body-1 element-section-label">
				{{ 'mes.administration.terminaltemplate.shared.unit-list' | translate }}
			</mat-label>

			<div cdkDropList [cdkDropListOrientation]="'vertical'" (cdkDropListDropped)="onDropUnit($event)">
				@for (unit of unitList.controls; track unit; let i = $index) {
					<div class="drag-row" [formGroup]="unit" cdkDrag cdkDragLockAxis="y">
						<mat-form-field appearance="fill" class="flex-fill">
							<mat-icon matPrefix cdkDragHandle class="drag-icon">reorder</mat-icon>
							<input maxlength="255" matInput formControlName="title" placeholder="{{ 'mes.administration.terminaltemplate.shared.title' | translate }}" />
						</mat-form-field>
						<mat-form-field appearance="fill" class="flex-fill">
							<input maxlength="255" matInput formControlName="source" placeholder="{{ 'mes.administration.terminaltemplate.shared.source' | translate }}" />
						</mat-form-field>
						<mat-form-field appearance="fill" class="type-width">
							<mat-select formControlName="datatype">
								@for (type of dataTypes; track type) {
									<mat-option [value]="type">
										{{ 'mes.administration.terminaltemplate.shared.types.' + type.toLowerCase() | translate }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
						<mat-form-field appearance="fill" class="format-width">
							<input maxlength="255" matInput [maxlength]="255" formControlName="format" placeholder="{{ 'mes.administration.terminaltemplate.shared.format' | translate }}" />
						</mat-form-field>
						<mat-form-field appearance="fill" class="format-sort">
							<button mat-icon-button matSuffix class="delete-button" (click)="deleteUnitListItem(i)" type="button">
								<mat-icon svgIcon="acies_delete"></mat-icon>
							</button>
							<mat-select formControlName="sort">
								@for (sort of sortSettings; track sort) {
									<mat-option [value]="sort">
										{{ 'mes.administration.terminaltemplate.shared.sort-settings.' + sort.toLowerCase() | translate }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					</div>
				}
			</div>

			<button mat-icon-button class="add-button" (click)="addUnitListItem()">
				<mat-icon svgIcon="acies_add_alt"></mat-icon>
			</button>

			<mat-label class="mat-body-1 detail-section-label">
				{{ 'mes.administration.terminaltemplate.shared.detail-view' | translate }}
			</mat-label>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.terminaltemplate.shared.html-template' | translate }}
				</mat-label>
				<textarea maxlength="200000" matInput formControlName="detailView" class="vertical-resize"></textarea>
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<div>
		<div mat-dialog-actions align="end">
			<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid">
				{{ 'mes.administration.terminaltemplate.shared.savebtn' | translate }}
			</button>
			<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
				{{ 'mes.administration.terminaltemplate.shared.cancelbtn' | translate }}
			</button>
		</div>
	</div>
</form>
